import { IFormRender, Label, TextFormField } from '@busybusy/webapp-react-ui';
import { t } from 'utils/localize';
import { v_phone, v_require } from 'utils/validations';

export interface IPhoneFormFieldProps<FormType extends { [field: string]: any }> {
  form: IFormRender<FormType>;
  name: keyof FormType & string;
  labelClassName?: string;
  onFocus?: () => void;
  onBlur?: () => void;
}

const PHONE_VALIDATIONS = [{ validation: v_require }, { validation: v_phone }];

const PhoneFormField = <FormType extends { [field: string]: any }>({
  form,
  name,
  labelClassName,
  onFocus,
  onBlur,
}: IPhoneFormFieldProps<FormType>) => (
  <>
    <Label className={labelClassName} secondaryLabel={'(xxx-xxx-xxxx)'}>
      {t('Phone')} #
    </Label>
    <TextFormField
      type="tel"
      form={form}
      name={name}
      onFocus={onFocus}
      onBlur={onBlur}
      validations={PHONE_VALIDATIONS}
    />
  </>
);

export default PhoneFormField;
